// extracted by mini-css-extract-plugin
export default {"head":"Header_head__E5nNw","navBar":"Header_navBar__SaYWZ","headline":"Header_headline__NnCXe","wave":"Header_wave__q2spU"};